import { useCallback, useEffect, useState } from "react";
import { uploadUrl } from "../../lib/assets";
import { albumPhotoBackground, masonryColumnCount } from "../../lib/albumsUtils";

/**
 * @param {{ album: import("../../data/albums").Album, onBack: () => void, onOpenLightbox: (photos: import("../../data/albums").AlbumPhoto[], index: number) => void }} props
 */
export default function AlbumDetail({ album, onBack, onOpenLightbox }) {
  const [columns, setColumns] = useState(() => masonryColumnCount(window.innerWidth));
  const [shareLabel, setShareLabel] = useState("Copy Share Link");

  useEffect(() => {
    const onResize = () => setColumns(masonryColumnCount(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const copyShareLink = useCallback(async () => {
    const url = `${window.location.origin}${window.location.pathname}#${album.id}`;
    try {
      await navigator.clipboard.writeText(url);
      setShareLabel("LINK COPIED");
      window.setTimeout(() => setShareLabel("Copy Share Link"), 2000);
    } catch {
      setShareLabel("COPY FAILED");
      window.setTimeout(() => setShareLabel("Copy Share Link"), 2000);
    }
  }, [album.id]);

  return (
    <div className="albums-page albums-detail">
      <section
        className="albums-detail__hero"
        style={{ background: albumPhotoBackground(album.cover) }}
      >
        <div className="albums-detail__hero-scrim" />
        <div className="albums-detail__hero-content">
          <div className="albums-detail__eyebrow">PRIVATE ALBUM</div>
          <h1 className="albums-detail__title">{album.title}</h1>
          <div className="albums-detail__meta">
            <span className="albums-detail__subtitle">{album.subtitle}</span>
            <span className="albums-detail__count">· {album.count} PHOTOGRAPHS</span>
          </div>
        </div>
      </section>

      <section className="albums-detail__body">
        <div className="albums-detail__toolbar">
          <button type="button" className="albums-detail__back" onClick={onBack}>
            <span aria-hidden="true">←</span> ALL ALBUMS
          </button>
          <button type="button" className="albums-detail__share" onClick={copyShareLink}>
            {shareLabel}
          </button>
        </div>

        <div className="albums-detail__grid" style={{ columnCount: columns }}>
          {album.photos.map((photo, index) => (
            <button
              key={`${photo.title}-${index}`}
              type="button"
              className="album-masonry-tile"
              onClick={() => onOpenLightbox(album.photos, index)}
            >
              {photo.image ? (
                <img src={uploadUrl(photo.image)} alt={photo.title} />
              ) : (
                <div
                  className="album-masonry-tile__placeholder"
                  style={{
                    height: photo.h || 280,
                    background: photo.grad,
                  }}
                />
              )}
              <div className="album-masonry-tile__overlay">
                <div className="album-masonry-tile__title">{photo.title}</div>
                <div className="album-masonry-tile__subtitle">{photo.subtitle}</div>
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
